import { render, staticRenderFns } from "./show.vue?vue&type=template&id=4d9c2f91&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=4d9c2f91&prod&scoped=true&lang=css&"
import style1 from "./show.vue?vue&type=style&index=1&id=4d9c2f91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c2f91",
  null
  
)

export default component.exports